export default __webpack_public_path__ + "img/3688b0bc7401f1d9bbf7418da33d3621.svg";